import { all } from 'redux-saga/effects';
import watchAuthSaga from './authSaga';
import watchAccountSaga from './accountSaga';

function* rootSaga() {
  yield all([watchAuthSaga(), watchAccountSaga()]);
}

export default rootSaga;
